export default "__VITE_ASSET__BhVpKr9U__"